import {
  TastyworksRest,
  type Logger,
  type SessionErrorHandler,
} from "@tastyworks/tastyworks-api"
import { isCookieAuthEnabled } from "/@lib/cookie-auth"
import session from "./session"

const logger: Logger = {
  warn: console.warn,
  info: console.info,
  error: console.error,
  log: console.log,
}

const sessionErrorHandler: SessionErrorHandler = {
  onInvalidSession: () => {
    // TODO
  },
  onOTPRequired: () => {
    // TODO: handle by 2fa#onSubmit
  },
  onHttpNetworkError: () => {
    // TODO: toastAlert("error", "HTTP Network Error", "Network Error"),
  },
}

export const twApiClient = new TastyworksRest.AdminClient(
  import.meta.env.VITE_TW_API_BASE_URL,
  logger,
  fetch.bind(window),
  sessionErrorHandler,
  session,
  () => (isCookieAuthEnabled() ? "cookie-csrf" : "bearer")
)

export { default as session } from "./session"
